import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Claims from './pages/Claims';
import Contact from './pages/Contact';
import InquiryForm from './pages/InquiryForm';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import InquiriesDashboard from './pages/admin/InquiriesDashboard';
import QuotationHistory from './pages/admin/QuotationHistory';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import AdminLayout from './pages/admin/AdminLayout';
// Quotation Builder Routes
import QuotationBuilderHome from './pages/admin/quotation-builder/QuotationBuilderHome';
// Motor Insurance
import PrivateCarInsurance from './pages/admin/quotation-builder/motor/PrivateCarInsurance';
import TwoWheelerInsurance from './pages/admin/quotation-builder/motor/TwoWheelerInsurance';
import CommercialVehicleInsurance from './pages/admin/quotation-builder/motor/CommercialVehicleInsurance';
import PassengerCarryingVehicle from './pages/admin/quotation-builder/motor/PassengerCarryingVehicle';
import GoodsCarryingVehicle from './pages/admin/quotation-builder/motor/GoodsCarryingVehicle';
// Non-Motor Insurance
import FireInsurance from './pages/admin/quotation-builder/non-motor/FireInsurance';
import PackageInsurance from './pages/admin/quotation-builder/non-motor/PackageInsurance';
import EngineeringInsurance from './pages/admin/quotation-builder/non-motor/EngineeringInsurance';
import TravelInsurance from './pages/admin/quotation-builder/non-motor/TravelInsurance';
// Health Insurance - Retail
import HealthInsurance from './pages/admin/quotation-builder/health/retail/HealthInsurance';
// Health Insurance - Group
import GeneralGroupHealth from './pages/admin/quotation-builder/health/group/GeneralGroupHealth';
import './App.css';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Routes>
            {/* Public routes with Navbar + Footer layout */}
            <Route path="/" element={
              <>
                <Navbar />
                <Outlet />
                <Footer />
              </>
            }>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="products" element={<Products />} />
              <Route path="claims" element={<Claims />} />
              <Route path="contact" element={<Contact />} />
              <Route path="inquiry" element={<InquiryForm />} />
            </Route>
            
            {/* Admin Login MUST be outside public layout */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected admin routes */}
            <Route path="/admin/*" element={
              <PrivateRoute>
                <AdminLayout>
                  <Routes>
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="inquiries" element={<InquiriesDashboard />} />
                    <Route path="quotation-builder" element={<QuotationBuilderHome />} />
                    
                    {/* Motor Insurance Routes */}
                    <Route path="quotation-builder/motor/car" element={<PrivateCarInsurance />} />
                    <Route path="quotation-builder/motor/bike" element={<TwoWheelerInsurance />} />
                    <Route path="quotation-builder/motor/cv" element={<CommercialVehicleInsurance />} />
                    <Route path="quotation-builder/motor/pcv" element={<PassengerCarryingVehicle />} />
                    <Route path="quotation-builder/motor/gcv" element={<GoodsCarryingVehicle />} />
                    
                    {/* Non-Motor Insurance Routes */}
                    <Route path="quotation-builder/non-motor/fire" element={<FireInsurance />} />
                    <Route path="quotation-builder/non-motor/package" element={<PackageInsurance />} />
                    <Route path="quotation-builder/non-motor/engineering" element={<EngineeringInsurance />} />
                    <Route path="quotation-builder/non-motor/travel" element={<TravelInsurance />} />
                    
                    {/* Health Insurance - Retail Routes */}
                    <Route path="quotation-builder/health/retail/health" element={<HealthInsurance />} />
                    
                    {/* Health Insurance - Group Routes */}
                    <Route path="quotation-builder/health/group/general-group" element={<GeneralGroupHealth />} />
                    
                    <Route path="quotation-history" element={<QuotationHistory />} />
                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                  </Routes>
                </AdminLayout>
              </PrivateRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;


